import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../shared/services/api.service';
import { PartnerModel } from '../partner.model';
import { UtilService } from '../../../shared/services/util.service';

@Component({
  standalone: false,
  selector: 'app-add-partner',
  templateUrl: './add-partner.component.html',
  styleUrl: './add-partner.component.scss'
})
export class AddPartnerComponent implements OnInit {

  @Input() newPartner: any;
  @Output() onSave = new EventEmitter<boolean>();
  countries: any[] = [];
  selectedDestinationCountries: string[] = [];
  errorMessage: string = '';

  constructor(private activeModal: NgbActiveModal,
    private _api: ApiService,
    private _util: UtilService
  ) { }

  ngOnInit() {
    const vm = this;
    vm.getCountries();
    if (vm.newPartner && vm.newPartner._id) {
      vm.newPartner = vm.newPartner;
      if (vm.newPartner.isRefundEnabled === undefined) {
        vm.newPartner.isRefundEnabled = false;
      }
      if (vm.newPartner.isDisputeEnabled === undefined) {
        vm.newPartner.isDisputeEnabled = false;
      }
      // Handle originationCountryId - convert object to string ID if needed
      if (vm.newPartner.originationCountryId) {
        if (typeof vm.newPartner.originationCountryId === 'object') {
          vm.newPartner.originationCountryId = vm.newPartner.originationCountryId._id;
        }
      }
      if (vm.newPartner.destinationCountries && Array.isArray(vm.newPartner.destinationCountries)) {
        vm.selectedDestinationCountries = vm.newPartner.destinationCountries.map((item: any) => {
          return typeof item === 'string' ? item : (item._id || item);
        });
      } else {
        vm.selectedDestinationCountries = [];
      }
    } else {
      vm.newPartner = new PartnerModel();
      vm.newPartner.isRefundEnabled = false;
      vm.newPartner.isDisputeEnabled = false;
      vm.newPartner.destinationCountries = [];
      vm.newPartner.remittanceCommission = 0;
      vm.selectedDestinationCountries = [];
    }
  }

  getCountries() {
    const vm = this;
    const type = 'country';
    const apiUrl = '/admin/get-data?type=' + type + '&_limit=500';
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {
        // Sort countries alphabetically by displayName or name
        vm.countries = res.data.sort((a: any, b: any) => {
          const nameA = (a.displayName || a.name || '').toLowerCase();
          const nameB = (b.displayName || b.name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
      }
    });
  }

  onDestinationCountriesChange() {
    const vm = this;
    vm.newPartner.destinationCountries = vm.selectedDestinationCountries;
  }

  onClose() {
    const vm = this;
    vm.activeModal.close(true);
  }


  onSubmit(formData: any) {
    const vm = this;
    vm.errorMessage = ''; // Clear previous errors
    
    if (formData.valid) {
      vm.newPartner.destinationCountries = vm.selectedDestinationCountries;
      const apiUrl = vm.newPartner._id ? '/admin/create-partner/update' : '/admin/create-partner';
      
      vm._api.postData(apiUrl, vm.newPartner).subscribe({
        next: (res: any) => {
          if (res && !res.error) {
            vm.activeModal.close(true);
            vm.onSave.emit();
            vm._util.navigate('/app/partners');
          } else {
            // Handle API error response
            vm.errorMessage = res.message || 'An unknown error occurred';
          }
        },
        error: (err: any) => {
          // Handle HTTP error response
          console.log('Full error object received:', JSON.stringify(err, null, 2));
          
          // Try to extract a meaningful error message
          let errorMsg = '';
          
          if (err && err.error && err.error.message) {
            errorMsg = err.error.message;
          } else if (err && err.message) {
            errorMsg = err.message;
          } else if (err && typeof err === 'string') {
            errorMsg = err;
          } else if (err && err.error && typeof err.error === 'string') {
            errorMsg = err.error;
          } else if (err && err.status && err.statusText) {
            errorMsg = `HTTP ${err.status}: ${err.statusText}`;
          }
          
          // If we still don't have a meaningful message, provide a generic one
          if (!errorMsg || errorMsg.includes('undefined')) {
            // Check if this is a 400 error which typically has validation messages
            if (err && err.status === 400) {
              errorMsg = 'Validation failed. Please check all required fields are filled correctly.';
            } else {
              errorMsg = 'An error occurred while saving the partner. Please try again.';
            }
          }
          
          vm.errorMessage = errorMsg;
        }
      });
    }
  }


}